import React from "react";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../components/BackgroundWrapper";

export default function Programs() {
  return (
    <BackgroundWrapper>
       <div className="pt-8 pb-20 px-4 min-h-screen">
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 pt-8 pb-20 backdrop-blur-md rounded-3xl shadow-2xl">
           
      <div className="w-full px-3 sm:px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <Link
            to="/"
            className="mb-8 inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold"
          >
            ← Back to Home
          </Link>

          <div className="bg-white/90 backdrop-blur-md rounded-2xl sm:rounded-3xl shadow-2xl p-2 sm:p-8 md:p-12">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-800 mb-8 sm:mb-12 text-center">
              Our Programs
            </h1>

            <div className="grid md:grid-cols-2 gap-6 mb-8 sm:mb-16">
              <Link
                to="/strategic-advisory"
                className="bg-gradient-to-br from-blue-600 to-indigo-600 text-white rounded-2xl sm:rounded-3xl p-4 sm:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 text-left"
              >
                <h3 className="text-xl sm:text-2xl font-bold mb-4">
                  Strategic Advisory Services
                </h3>
                <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
                  <li>Strategic assessment of leadership capabilities</li>
                  <li>Geo-political risk assessment</li>
                  <li>People, systems and process risks</li>
                  <li>Strategy implementation gaps</li>
                  <li>Investment risks and opportunities</li>
                </ul>
                <p className="mt-4 text-xs sm:text-sm opacity-90">Click to learn more →</p>
              </Link>

              <Link
                to="/org-change"
                className="bg-gradient-to-br from-indigo-600 to-purple-600 text-white rounded-2xl sm:rounded-3xl p-4 sm:p-8 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 text-left"
              >
                <h3 className="text-xl sm:text-2xl font-bold mb-4">
                  Organizational Change Management
                </h3>
                <ul className="space-y-2 sm:space-y-3 text-xs sm:text-sm">
                  <li>Organizational effectiveness improvement</li>
                  <li>Group behavior and culture change</li>
                  <li>Success factors for new models</li>
                  <li>Employee engagement enhancement</li>
                </ul>
                <p className="mt-4 text-xs sm:text-sm opacity-90">Click to learn more →</p>
              </Link>
            </div>

            <div className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-2xl sm:rounded-3xl p-4 sm:p-8 md:p-12 shadow-xl">
              <h3 className="text-base sm:text-xl font-bold text-slate-800 mb-6 sm:mb-8 md:mb-12 text-center">
                Leadership Development Programs
              </h3>

              <div className="grid md:grid-cols-3 gap-4 sm:gap-6 md:gap-8 mb-6 sm:mb-8 md:mb-12">
                <Link
                  to="/leadership-toolkit"
                  className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-4 shadow-lg hover:shadow-xl transition-all text-left"
                >
                  <div className="bg-gradient-to-br from-blue-100 to-blue-50 w-14 sm:w-16 h-14 sm:h-16 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                    <span className="text-xl sm:text-2xl font-bold text-blue-600">1</span>
                  </div>
                  <h4 className="text-lg sm:text-xl font-bold text-slate-800 mb-2 sm:mb-3">
                    The Leadership Toolkit
                  </h4>
                  <p className="text-sm sm:text-base text-slate-600 mb-3 sm:mb-4">
                    Designed for senior executives to develop into leaders
                  </p>
                  <p className="text-xs sm:text-sm text-blue-600 font-semibold">
                    Click to learn more → 
                  </p>
                </Link>

                <Link
                  to="/leaders-agenda"
                  className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-4 shadow-lg hover:shadow-xl transition-all text-left"
                >
                  <div className="bg-gradient-to-br from-indigo-100 to-indigo-50 w-14 sm:w-16 h-14 sm:h-16 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                    <span className="text-xl sm:text-2xl font-bold text-indigo-600">2</span>
                  </div>
                  <h4 className="text-lg sm:text-xl font-bold text-slate-800 mb-2 sm:mb-3">
                    The Leader's Agenda
                  </h4>
                  <p className="text-sm sm:text-base text-slate-600 mb-3 sm:mb-4">
                    Transition support for new roles
                  </p>
                  <p className="text-xs sm:text-sm text-indigo-600 font-semibold">
                    Click to learn more →
                  </p>
                </Link>

                <Link
                  to="/enlightened-leadership"
                  className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-4 shadow-lg hover:shadow-xl transition-all text-left"
                >
                  <div className="bg-gradient-to-br from-purple-100 to-purple-50 w-14 sm:w-16 h-14 sm:h-16 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                    <span className="text-xl sm:text-2xl font-bold text-purple-600">3</span>
                  </div>
                  <h4 className="text-lg sm:text-xl font-bold text-slate-800 mb-2 sm:mb-3">
                    Enlightened Leadership
                  </h4>
                  <p className="text-sm sm:text-base text-slate-600 mb-3 sm:mb-4">
                    Comprehensive transformation program
                  </p>
                  <p className="text-xs sm:text-sm text-purple-600 font-semibold">
                    Click to learn more →
                  </p>
                </Link>
              </div>

         

 <Link
                to="/c-level-coaching"
              >
    <div className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl sm:rounded-2xl p-4 sm:p-8 shadow-xl hover:shadow-2xl transition-all">
      <h4 className="text-lg sm:text-2xl font-bold mb-3 sm:mb-4">
        C-Level Mentoring & Coaching
      </h4>
      <p className="text-sm sm:text-base md:text-lg mb-6 sm:mb-8">
        One-to-one or group mentoring and coaching sessions for senior
        executives facing challenges or adapting to change.
      </p>
      <p className="text-xs sm:text-sm font-semibold">Click to learn more →</p>
      
    </div>
 </Link>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    </div>
    </BackgroundWrapper>
  );
}
